import { useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useAuth } from "../../providers/Auth";
import { Link, useHistory } from "react-router-dom";

import AsideImage from "../../assets/images/loginImage.jpeg";

import { TextField, Button, CircularProgress } from "@mui/material";

import { Container, Form, FormContainer } from "./styles";

interface SignInData {
  username: string;
  email: string;
  password: string;
  confirm_password?: string;
}

const signInSchema = yup.object().shape({
  username: yup.string().required("Username obrigatório"),
  email: yup.string().required("Email obrigatório").email("Email inválido"),
  password: yup.string().required("Senha obrigatória"),
  confirm_password: yup
    .string()
    .required("Confirmação de senha obrigatória")
    .oneOf([yup.ref("password"), null], "Senhas diferentes"),
});

const Signup = () => {
  const [loading, setLoading] = useState(false);
  const { signUp } = useAuth();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<SignInData>({ resolver: yupResolver(signInSchema) });

  const handleSignIn = (data: SignInData) => {
    setLoading(true);

    delete data.confirm_password;

    signUp(data)
      .then((_) => {
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  return (
    <Container className="rpgui-content">
      <FormContainer className="rpgui-container framed-golden status">
        <Form onSubmit={handleSubmit(handleSignIn)}>
          <h1>Cadastro</h1>
          <TextField
            fullWidth
            autoComplete="username"
            label={!!errors.username ? errors.username.message : "Username"}
            variant="outlined"
            {...register("username")}
            error={!!errors.username}
          />

          <TextField
            fullWidth
            autoComplete="email"
            label={!!errors.email ? errors.email.message : "Email"}
            variant="outlined"
            {...register("email")}
            error={!!errors.email}
          />
          <TextField
            fullWidth
            label={!!errors.password ? errors.password.message : "Senha"}
            variant="outlined"
            type="password"
            {...register("password")}
            error={!!errors.password}
          />
          <TextField
            fullWidth
            label={
              !!errors.confirm_password
                ? errors.confirm_password.message
                : "Confirmar senha"
            }
            variant="outlined"
            type="password"
            {...register("confirm_password")}
            error={!!errors.confirm_password}
          />

          <Button
            variant="contained"
            color="primary"
            disabled={loading}
            type="submit"
            className="rpgui-button"
          >
            {loading ? <CircularProgress /> : "Cadastrar"}
          </Button>
          <p>
            Já possui um cadastro? <Link to="/login">Clique aqui</Link> para
            fazer o seu login!
          </p>
        </Form>
      </FormContainer>
    </Container>
  );
};

export default Signup;
